import styled from "styled-components";

export const SetsPageContainer = styled.div`
    box-sizing: border-box;
    display: flex;
    flex-direction: column;
    gap: 24px;
    padding: 0px 48px;
    padding-bottom: 48px;
    width: 100%;
`;

export const SetListContainer = styled.div`
    align-items: start;
    box-sizing: border-box;
    display: flex;
    flex-direction: column;
    gap: 16px;
    width: 100%;
`;
export const Header = styled.div`
    align-items: center;
    display: flex;
    justify-content: space-between;
    width: 100%;
`;
export const LeftContent = styled.div`
    align-items: center;
    display: flex;
    gap: 24px;
`;
export const CheckboxContainer = styled.div`
    align-items: center;
    display: flex;
    gap: 8px;

    h4 {
        white-space: nowrap;
        user-select: none;
        -webkit-touch-callout: none;
        -webkit-user-select: none;
        -khtml-user-select: none;
        -moz-user-select: none;
        -ms-user-select: none;
    }
`;
export const MultiSelectCheckbox = styled.input`
    height: 18px;
    opacity: 0.4;
    transition: opacity 0.2s ease;
    width: 18px;
    
    &:hover {
        opacity: 1.0;
    }
`;
export const ButtonContainer = styled.div`
    align-items: center;
    display: flex;
    gap: 8px;
`;
export const RightContent = styled.div`
    align-items: center;
    display: flex;
    gap: 8px;
    max-width: 540px;
    width: 100%;
`;
export const SetsList = styled.div`
    display: grid;
    grid-template-columns: repeat(auto-fill, minmax(300px, 1fr));
    gap: 16px;
    width: 100%;
`;
export const EmptyState = styled.div`
    align-items: center;
    background: rgba(255, 255, 255, 0.05);
    border: 1px dashed rgba(255, 255, 255, 0.2);
    border-radius: 8px;
    display: flex;
    flex-direction: column;
    gap: 16px;
    justify-content: center;
    text-align: center;
    min-height: 180px;
    width: 100%;
`;